export const BASE_URL = process.env.BASE_URL || 'http://localhost:8090';
export const OAUTH_URL =  window.CONFIG.VUE_APP_OAUTH_URL;
export const OAUTH_REALM = window.CONFIG.VUE_APP_OAUTH_REALM;
export const OAUTH_CLIENT_ID = window.CONFIG.VUE_APP_OAUTH_CLIENT_ID;
